import React from "react";
import "../resources/dropdown.css";

function withDropdown(Component, items, styles, ...rest) {
  return class WithDropdown extends React.Component {
    state = {
      showDropdown: false,
    };

    mouseOver = () => this.setState({ showDropdown: true });
    mouseOut = () => this.setState({ showDropdown: false });

    render() {
      return (
        <div
          className="dropdown-container"
          onMouseOver={this.mouseOver}
          onMouseOut={this.mouseOut}
          style={styles}
          {...rest}
        >
          <div className="dropdown-label">
            <Component {...this.props} />
          </div>
          {this.state.showDropdown && (
            <div className="dropdown-items">
              {items}
            </div>
          )}
        </div>
      );
    }
  };
}

export default withDropdown;
